import { CButton, CContainer } from '@coreui/react'
import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { publicApi, apiErrorMessage } from '../../api/client'
import { EmptyState, ErrorState, LoadingState } from '../../components/common/AsyncState'
import { SectionHeader } from '../../components/common/SectionHeader'
import { ServiceCard } from '../../components/public/ServiceCard'
import { useAuth } from '../../auth/AuthProvider'

export function ServicesPage() {
  const query = useQuery({
    queryKey: ['public', 'services'],
    queryFn: publicApi.services,
    refetchInterval: 60_000,
  })
  const { user } = useAuth()
  return (
    <>
      <section className="page-hero page-hero--services">
        <CContainer xxl>
          <span className="eyebrow">Research services</span>
          <h1>Purpose and status are public. Launch access remains protected.</h1>
          <p>
            Service endpoints and member permissions are released only after FreeIPA authentication and
            group checks.
          </p>
        </CContainer>
      </section>
      <section className="section-space--tight">
        <CContainer xxl>
          <SectionHeader
            eyebrow="Live catalogue"
            title="Approved LARICE services"
            description="Operational status can remain visible even when instantaneous GPU processing is low between requests."
            action={
              <CButton color="primary" as={Link} to={user ? '/console/services' : '/login'}>
                {user ? 'Open launchpad' : 'Member sign in'}
              </CButton>
            }
          />
          {query.isLoading && <LoadingState />}
          {query.isError && <ErrorState message={apiErrorMessage(query.error)} />}
          {query.data &&
            (query.data.length ? (
              <div className="service-grid">
                {query.data.map((item) => (
                  <ServiceCard key={item._id} service={item} />
                ))}
              </div>
            ) : (
              <EmptyState
                title="No public services listed"
                description="Approved services will appear here after catalogue review."
              />
            ))}
        </CContainer>
      </section>
    </>
  )
}
